import { dateFormat } from '@carm/shared/constants/const-carm';
import { TranslateService } from '@ngx-translate/core';
import * as dayjs from 'dayjs';
import { IRulingInfo } from '.';
import { IApiRulingListItem } from './ruling-api.model';
import { IRulingDraftListItemResponse } from './ruling-draft-api.model';
import { IRulingDraftInfo } from './ruling-draft-form.model';

export const mapApiResultToRulingDraftInfo = (item: IRulingDraftListItemResponse, translator: TranslateService): IRulingDraftInfo => {
  return {
    draftId: item.uid,
    savedOn: dayjs(item.lastModifiedDate).format(dateFormat),
    savedOnTooltip: dayjs(item.lastModifiedDate).format('YYYY-MM-DD hh:mm A'),
    name: item.name,
    type: item.type,
    typeText: item.type ? translator.instant('concepts.rulings.type.' + item.type) : '',
    statusCode: item.statusCode,
    statusLocalizedText: translator.instant('concepts.rulings.status.' + item.statusName),
  } as IRulingDraftInfo;
};

export const mapApiResultToRulingInfo = (rulingListItem: IApiRulingListItem, translator: TranslateService, lang: string): IRulingInfo => {
  return {
      caseNumber: rulingListItem.caseNumber,
      dateSubmitted: dayjs(rulingListItem.dateSubmitted, dateFormat).toDate(),
      dateSubmittedText: rulingListItem.dateSubmitted,
      submittedBy: rulingListItem.submittedByName + ' (' + rulingListItem.submittedByBN + ')',
      rulingType: rulingListItem.rulingType ? rulingListItem.rulingType : 'NOT_DEFINED',
      rulingTypeText: translator.instant( rulingListItem.rulingType ? 'concepts.rulings.type.'
                  + rulingListItem.rulingType : 'concepts.rulings.type.NOT_DEFINED'),
      status: rulingListItem.status,
      statusText: rulingListItem.statusMsg,
      createdByCBSA: rulingListItem.createdByCBSA,
      appealPermitted: rulingListItem.appealPermitted,
      appealRequiresRFE: rulingListItem.appealRequiresRFE,
      hybrisCaseStatus: rulingListItem.hybrisCaseStatus,
      caseType: rulingListItem.caseType
    } as IRulingInfo;
};
